var container = document.querySelector('.instagram__items');
if(container) {
  var html = "";
  var request = new XMLHttpRequest();
  request.open('POST', 'instagram.php', true);
  request.onload = function(){
    var requestObj = JSON.parse(this.responseText);
    if(request.readyState === 4 ) {
      if(request.status === 200 ) {
        var instaData = requestObj.media.data;

        var count = 0;
        for(var i = 0, len = instaData.length; i < len; i++) {
          var imgurl = instaData[i].media_url;
          var link = instaData[i].permalink;

          if(instaData[i].media_type == 'IMAGE') {
            html += '<li><a href="' + link + '" target="_blank" style="background-image: url(' + imgurl + ')"></a></li>';
            count++;
            if(count == 9) {
              break;
            }
          }

        }
        container.innerHTML = html;
      } else {
        html += '<li>No Images</li>';
      }
    }
  };
  request.send(null);
}

